import { type Country, countries, type Language, languages } from 'countries-list';
import memoize from 'lodash/memoize';

export type Locale = {
  language: Language;
  country?: Country;
};

type LanguageCode = keyof typeof languages;
type CountryCode = keyof typeof countries;

function getLanguage(str: string): Language {
  if (str in languages) {
    return languages[str as LanguageCode];
  }

  throw new Error(`Invalid language code "${str}"`);
}

function getCountry(str: string): Country {
  if (str in countries) {
    return countries[str as CountryCode];
  }

  throw new Error(`Invalid country code "${str}"`);
}

export const parseLocaleCode = memoize((code: string): Locale => {
  const parts = code.split('-');
  const result: Locale = {
    language: {
      ...getLanguage(parts[0])
    }
  };

  if (parts.length === 2) {
    result.country = {
      ...getCountry(parts[1].toUpperCase())
    };
  }

  return result;
});

export function getLocaleCode(locale: { language: string; country?: string }): string {
  return locale.country ? `${locale.language}-${locale.country}` : locale.language;
}
